import { type Layout } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import type { RibbonGroupId } from "owa-ribbon-ids";

export const getMLRSendReceiveTabGroupLayouts: (_group: RibbonGroupId, _props: ReadOnlyRibbonControlDefProps) => Layout[] | undefined = owaComputedFn(function getMLRSendReceiveTabGroupLayouts(_group: RibbonGroupId, _props: ReadOnlyRibbonControlDefProps): Layout[] | undefined {
    // Send/receive tab has no group layouts
    return undefined;
});
